/**
 * Страница менеджера: список сообщений по проектам (manager/projectscomments).
 *
 * Маркер инициализации — таблица #messages-table.
 * Без конфига (Blade-переменных в скрипте не было).
 *
 * Функционал:
 *   - debounced поиск + фильтр по типу пользователя;
 *   - переход по строке при клике;
 *   - управление видимостью пагинации и "нет результатов".
 */

function init() {
    if (!document.getElementById('messages-table')) return;

    const $ = window.jQuery || window.$;
    if (!$) {
        console.error('[manager-projects-comments] jQuery not loaded');
        return;
    }

    $(() => {
        let searchTimeout;

        function filterTable() {
            const searchValue = $('#adm_search_input').val().toLowerCase().trim();
            const selectedTypes = [];

            $('.filter-checkbox:checked').each(function () {
                selectedTypes.push($(this).val());
            });

            let visibleRows = 0;

            $('#messages-table tbody tr').each(function () {
                const row = $(this);
                const userType = String(row.data('user-type') || '').trim();
                const rowText = row.text().toLowerCase();

                const searchMatch = searchValue === '' || rowText.includes(searchValue);
                const typeMatch = selectedTypes.length === 0 || selectedTypes.includes(userType);

                if (searchMatch && typeMatch) {
                    row.show();
                    visibleRows++;
                } else {
                    row.hide();
                }
            });

            if (visibleRows === 0) {
                $('#no-results').show();
                $('.pagination').hide();
            } else {
                $('#no-results').hide();
                if (searchValue === '' && selectedTypes.length === 0) {
                    $('.pagination').show();
                } else {
                    $('.pagination').hide();
                }
            }
        }

        $('#adm_search_input').on('input keyup', function () {
            clearTimeout(searchTimeout);
            searchTimeout = setTimeout(filterTable, 300);
        });

        $(document).on('change', '.filter-checkbox', filterTable);

        $('#messages-table tbody tr').on('click', function (e) {
            if ($(e.target).is('input[type="checkbox"]')) return;
            const href = $(this).data('href');
            if (href) window.location.href = href;
        });

        $('.adm_search_button').on('click', function (e) {
            e.preventDefault();
            filterTable();
        });

        $('#adm_search_input').on('keypress', function (e) {
            if (e.which === 13) {
                e.preventDefault();
                filterTable();
            }
        });
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
